import { Box, styled } from "@mui/material";
import { ILayout } from "./LayoutInterfaces";
import CssBaseline from "@mui/material/CssBaseline";
import { useStyles } from "./Layout.styles";
import AppDrawer from "./AppDrawer/AppDrawer.view";

// Cedar rebrand: no persistent side drawer, so the main content fills the full
// width below the fixed top bar (pages already offset themselves by the 64px bar).
const Main = styled("main")({
    flexGrow: 1,
    minWidth: 0,
});

const Layout = ({ children, appDrawerItems, navLabel }: ILayout) => {
    const classes = useStyles();
    return (
        <Box className={classes.mainBox}>
            <CssBaseline />
            <AppDrawer appDrawerItems={appDrawerItems} navLabel={navLabel} />
            <Main>{children}</Main>
        </Box>
    );
};

export default Layout;
